module.exports = __webpack_public_path__ + "2e525474bfd4a27e393e30eac96a923c.svg";